module.exports = __webpack_public_path__ + "static/media/bendigo-tafe.07c00d7b.jpg";